/** Format a payment line amount; reductions display in parentheses e.g. ($25). */
export function formatPaymentReconciliationAmount(
  amount: unknown,
  isReduction?: boolean
): string {
  if (amount === null || amount === undefined) {
    return isReduction ? '($0)' : '$0';
  }
  const num = parseFloat(String(amount).replace(/[$,()]/g, ''));
  const formatted = !isNaN(num) ? Math.round(num).toString() : '0';
  return isReduction ? `($${formatted})` : `$${formatted}`;
}
